"use client";

import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "./DoctorProfileTabsDoctor.css";

export default function DoctorProfileTabsDoctor({ active, onChange }) {
  const { t, i18n } = useTranslation();
  const isRTL = (i18n.language || "").startsWith("ar");

  const TABS = useMemo(
    () => [
      { key: "info", label: t("doctorProfileTabs.info", "Info") },
      { key: "posts", label: t("doctorProfileTabs.posts", "Posts") },
      { key: "followers", label: t("doctorProfileTabs.followers", "Followers") }, // ✅ NEW
      { key: "saved", label: t("doctorProfileTabs.saved", "Saved") },
    ],
    [t]
  );

  return (
    <div className={`ddpt-wrap ${isRTL ? "is-rtl" : ""}`} dir={isRTL ? "rtl" : "ltr"}>
      {TABS.map((tab) => (
        <button
          key={tab.key}
          className={`ddpt-tab ${active === tab.key ? "isActive" : ""}`}
          onClick={() => onChange?.(tab.key)}
          type="button"
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}